<template>
	<div class="list_box">

		<div class="title_box">
			<div class="title_l">
<!--				<span class="episode">第{{ episodeNum }}集</span>-->
				<span>{{ title }}</span>
			</div>
			<van-image class="title_icon" lazy-load fit="cover" :src="'./image/line.png'"/>
		</div>

		<div class="img_box">
<!--			<van-image class="video_img" lazy-load fit="cover" :src="img"/>-->
<!--			<van-image class="video_player" lazy-load fit="contain" :src="'/image/player.png'"/>-->
			<v-video :src="src" :poster="img"></v-video>
		</div>

		<div class="con_box">
			<div class="title_box">
				<div class="title_l">
					<span>简介</span>
				</div>
				<van-image class="title_icon" lazy-load fit="cover" :src="'./image/txt.png'"/>
			</div>
			<p class="con_txt">{{ text }}</p>
		</div>

	</div>
</template>

<script>
	import VVideo from '@/components/video'

	export default {
		name: "index",
		components: {
			VVideo
		},
		props: {
			index: {
				default: 1
			},
			title: {
				type: String,
				default: '金山岭长城'
			},
			img: {
				type: String,
				default: '/image/video_img.jpg'
			},
			src: {
				type: String,
				default: 'http://vjs.zencdn.net/v/oceans.mp4'
			},
			text: {
				type: String,
				default: '金山岭长城，位于河北省承德市滦平县境内，与北京市密云区相邻，距北京市区130公里。金山岭长城始建于明洪武元年（公元1368年），为大将徐达主持修建。金山岭长城，在隆庆元年（公元1567年）抗倭名将蓟镇总兵官戚继光、蓟辽总督谭纶在徐达所建长城的基础上续'
			}
		},
		data() {
			return {
				episodeCN: ['十', '一', '二', '三', '四', '五', '六', '七', '八', '九']
			}
		},
		computed: {
			episodeNum() {
				let num = this.index + '';
				let str = '';
				for(let i=0; i<num.length; i++) {
					str += this.episodeCN[ num[i] ];
				}
				return str
			}
		}
	}
</script>

<style scoped>
	.list_box {
		width: 80%;
		padding: 20px 0;
		margin: 0 auto;
	}

	.title_box {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #edd775;
		font-size: 14px;
		letter-spacing: 4px;
	}

	.episode {
		padding-right: 8px;
		border-right: 2px solid #edd775;
		margin-right: 10px;
	}

	.title_icon {
		width: 14px;
		height: 14px;
	}

	.img_box {
		width: 100%;
		/*height: 232px;*/
		margin: 12px 0 35px;
		box-sizing: content-box;
		border: 2px solid #e1a549;
		overflow: hidden;
		position: relative;
	}

	.video_img {
		width: 100%;
		height: 100%;
	}

	.video_player {
		width: 60px;
		height: 60px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.con_txt {
		font-size: 11px;
		text-indent: 30px;
		color: #edd775;
		margin-top: 15px;
		letter-spacing: 4px;
		line-height: 1.8;
	}
</style>